/**
 * 已有三种站外打开App的UI组件：OpenAppFromTop， OpenAppFromBottom， OpenAppFromContent
 * 当都不满足需求时，可再按需求实现后用 OpenLaunchApp 包裹
 * 注意: 样式中的position 定位需要放在外层，就像 OpenAppFromBottom 组件里实现的那样
 */
export { OpenAppFromTop, OpenAppFromBottom, OpenAppFromContent } from './OpenAppEle';

export { default as OpenLaunchApp } from './OpenLaunchApp';
